export default function Contact() {
  return (
    <div className="text-justify mb-10 px-4 lg:px-0 pt-4">
      <div className="flex flex-col">
        <span className="font-bold lg:text-sm uppercase tracking-widest">
          For workshop or interview inquiries.
        </span>
        <div className="lg:text-sm mt-2">
          Send an email with details:
          <a
            href="mailto:violetdanse@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="underline italic ml-2 mt-2 mb-8"
          >
            violetdanse@gmail.com
          </a>
        </div>
      </div>
      <div className="flex flex-col mt-8">
        <span className="font-bold lg:text-sm uppercase tracking-widest">
          For artistic collaborations or connections.
        </span>
        <div className="lg:text-sm mt-2">
          Send a direct message on Instagram:
          <a
            href="https://instagram.com/violetdanse"
            target="_blank"
            rel="noreferrer"
            className="ml-2 mt-2 lg:text-sm"
          >
            <span className="underline italic">@violetdanse</span>
          </a>
        </div>
      </div>
      <div className="italic text-justify text-sm mt-12">
        Response times vary.
      </div>
    </div>
  );
}
